module.exports = "/_next/static/images/olipop-testimonial-f9071c7d5ab831826beb15ae6221d0d3.jpg";